import type { ValidTerritoryCode } from "./territoryCodes";

export * from "./territoryCodes";

export * from "./isoCountries";

export * from "./stats.bigquery";

export * from "./videocall.constants";

export * from "./accesses";

export * from "./defaultAvatar";

export * from "./runtimeEnvironment";

export * from "./ticketLinks";

export * from "./event-time";

export * from "@libs/audio-publish-contracts"; // mediaUrls and privateAudioRevision, Audio publish's

export * from "./publicPreviewUrl";

export const TODAYS_TOP_HITS_ID = "todays_top_hits";

export const getTodaysTopHitsId = (territoryCode: ValidTerritoryCode) =>
  `${territoryCode.toLocaleLowerCase()}_${TODAYS_TOP_HITS_ID}`;

export const isTodaysTopHitsId = (
  id: string,
  territoryCode: ValidTerritoryCode,
) => id === getTodaysTopHitsId(territoryCode);

export * from "./private-song";

export { AudienceRateLimiter } from "./audience-rate-limit";
